import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { AuthContext } from '../../contexts/auth/Store';
import { OrderContext } from '../../contexts/order/Store';
import Config from '../../constants/Config';
import EditOrderItemCountModal from '../modals/EditOrderItemCountModal';
import { AnalyticsService } from '../../constants/Analytics'
import FontStyles from '../../constants/FontStyle';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';

const analytics = new AnalyticsService

function OrderItem({ item, order, updateOrder, order_length, can_update }) {

    // updateOrder --> type DELETE | UPDATE -> amount -> item_id

    const authContext = React.useContext(AuthContext);
    const token = authContext.getUserData.userToken;
    const buyer = authContext.getUserData.buyerData;

    const { action: order_fetch } = React.useContext(OrderContext);

    const [isSubmitting, setSubmitting] = React.useState(false)
    const [isEditing, setEditing] = React.useState(false)

    const openModal = () => {
        setEditing(true)
    }
    const hideModal = () => {
        setEditing(false)
    }
    const removeItem = () => {
        setSubmitting(true)

        let new_amount = order.amount - item.amount

        // console.log(new_amount)
        // return

        let form = new FormData()
        form.append('_id', item._id)

        let form_2 = new FormData()
        form_2.append('_id', order._id)
        form_2.append('ref', order.ref)
        form_2.append('payment', order.payment)
        form_2.append('tag', order.tag)
        form_2.append('meta', order.meta)
        form_2.append('amount', new_amount)
        form_2.append('manufacturer_id', order.manufacturer_id)
        form_2.append('seller_id', order.seller_id)
        form_2.append('buyer_id', order.buyer_id)
        form_2.append('sales_officer_id', order.sales_officer_id)

        let req_delete = http.post('order_item/delete', form, token)
        let req_update = http.post('order/update', form_2, token)

        Promise.all([req_delete, req_update]).then(([res_delete, res_update]) => {
            setSubmitting(false)
            try {
                if (res_delete.code === 200 || res_update.code === 200) {
                    order_fetch.then(res => { }).catch(e => { console.log(e) })
                    analytics.logEvent('Removed Order Item', buyer, {
                        order_item_id: item._id,
                        product_name: item.product.name
                    })
                    updateOrder('DELETE', new_amount, item._id)
                } else {
                    console.log('delete order item error:', res_delete, res_update)
                }
            } catch (e) {
                console.log(e)
            }
        }).catch(err => {
            setSubmitting(false)
            console.log(err)
        })
    }

    return <>

        { isEditing && <EditOrderItemCountModal isActive={isEditing} hideModal={hideModal} item={item} order={order} updateOrder={updateOrder} />}

        <View style={[styles.container, { opacity: isSubmitting ? 0.4 : 1 }]}>
            <View style={styles.imageContainer}>
                <Image source={{ uri: `${Config.uploadUrl}${item.product.upload.path}` }} style={styles.image} />
            </View>
            <View style={styles.contentContainer}>
                <Text style={styles.titleText} numberOfLines={2}>{item.product.name}</Text>
                <Text style={styles.subTitleText}>{item.product.case_count} {item.product.pricetag.mpu === item.product.case_count && item.product.pricetag.mpu === 1 ? item.product?.tags?.HIGHER_UNIT?.value : item.product?.tags?.LOWER_UNIT?.value + 's / ' + item.product?.tags?.HIGHER_UNIT?.value}</Text>
                <View style={styles.detailContainer}>
                    <View style={styles.priceDetailContainer}>
                        <Text style={styles.priceText}>{formatCurrency(item.amount)}</Text>
                        <TouchableOpacity
                            style={{ flexDirection: 'row', alignItems: 'center' }}
                            onPress={openModal}
                            disabled={!can_update || true}
                        >
                            <Text style={styles.qtyText}>{item.quantity} {item.product?.pricetag.mpu === item.product?.case_count && item.product?.pricetag.mpu === 1 ? `${item.product?.tags?.HIGHER_UNIT?.value}${item.quantity > 1 ? 's' : ''}` : item.product?.tags?.LOWER_UNIT?.value + 's'}</Text>
                            {
                                can_update && false
                                    ? <View style={{ paddingVertical: 4, paddingHorizontal: 8 }}>
                                        <Icon name="brush" size={14} color="grey" />
                                    </View>
                                    : null
                            }
                        </TouchableOpacity>
                    </View>
                    {
                        can_update && order_length && order_length > 1 && false
                            ? <TouchableOpacity style={styles.removeBtn} disabled={isSubmitting} onPress={removeItem} >
                                <Icon name="close" size={18} color="red" />
                            </TouchableOpacity>
                            : null
                    }
                </View>

            </View>
        </View>
        <View style={styles.hr}></View>
    </>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    contentContainer: {
        flex: 1,
        paddingTop: 14,
        paddingLeft: 10,
        paddingBottom: 10,
        paddingRight: 16,
    },
    imageContainer: {
        borderRightColor: 'rgba(0,0,0,0.05)',
        borderRightWidth: 1,
        borderStyle: 'solid',
        padding: 10,
    },
    image: {
        width: 64,
        height: undefined,
        aspectRatio: 64 / 72,
    },
    titleText: {
        ...FontStyles.dark,
        ...FontStyles.size13,
        ...FontStyles.lh18,
        ...FontStyles.normal,
    },
    subTitleText: {
        ...FontStyles.normal,
        ...FontStyles.gray,
        ...FontStyles.size12,
        ...FontStyles.lh14,
        marginTop: 6,
    },
    hr: {
        height: 1,
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.05)',
        // marginVertical: 15.5,
    },
    detailContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 12,
    },
    priceDetailContainer: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        flexShrink: 1,
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    priceText: {
        ...FontStyles.size15,
        ...FontStyles.lh18,
        ...FontStyles.bold,
        paddingRight: 8
    },
    qtyText: {
        ...FontStyles.gray,
    },
    removeBtn: {
        paddingLeft: 20,
        alignSelf: 'flex-end',
    }
});

export default OrderItem